export type HighlightColor = 'red' | 'green' | 'yellow'

export interface HighlightSegment {
  color?: HighlightColor
  text: string
}

/**
 * Parses inline highlight tags `<red>...</red>`, `<green>...</green>`,
 * `<yellow>...</yellow>` from a server-provided string into a list of
 * segments. Used by the meta-insights cards on the Inbox Analysis Detail
 * page so the frontend can render colored highlights.
 */
export function parseHighlights(input: string): HighlightSegment[] {
  if (!input) return []
  const re = /<(red|green|yellow)>([\s\S]*?)<\/\1>/g
  const out: HighlightSegment[] = []
  let last = 0
  let match: RegExpExecArray | null
  // eslint-disable-next-line no-cond-assign
  while ((match = re.exec(input)) !== null) {
    if (match.index > last) {
      out.push({ text: input.slice(last, match.index) })
    }
    out.push({
      color: match[1] as HighlightColor,
      text: match[2],
    })
    last = match.index + match[0].length
  }
  if (last < input.length) {
    out.push({ text: input.slice(last) })
  }
  return out
}
